import Joi, { allow } from '@hapi/joi'

export const CustomerBiometricSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select Group`,
        "any.required": `Group required`
    }),
    operationEntityId: Joi.number().invalid(0).required().label("Operatin Entity").messages({
        "any.invalid": `Select Operatin Entity`,
        "any.required": `Operatin Entity required`
    }),
    registrationNumber:  Joi.string().allow("", null).alphanum().max(10).required().label("Registration Number").messages({
        "string.pattern.base": `Please enter valid Registration Number`,
        "string.max": `Please enter {#limit} characters.`
    }),
    NIC: Joi.string().alphanum().max(50).required().allow("", null).label("NIC").messages({
        "string.pattern.base": `Please enter valid NIC`,
        "string.max": `Please enter {#limit} characters.`
    }),
}
export const CustomerSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operatin Entity").messages({
        "any.invalid": `Select Factory`,
        "any.required": `Factory required`
    }),

    collectionPointID: Joi.number().invalid(0).required().label("Collectionpoint").messages({
        "any.invalid": `Select Collectionpoint.`,
        "any.required": `Collectionpoint required`
    }),
    collectionCatagoryID: Joi.number().invalid(0).required().label("Collectioncatagory").messages({
        "any.invalid": `Select Collection Category.`,
        "any.required": `Collectionpoint required`
    }),
    customerCode: Joi.string().alphanum().max(20).required().label("Customer Code").messages({
        "string.empty": `Customer Code required`,
        "string.pattern.base": `Please enter valid Customer Code`,
        "string.max": `Please enter {#limit} characters.`
    }),
    title: Joi.string().max(3).required().label("Title").allow("").messages({
        "string.reqired": `Title required`,
        "string.pattern.base": `Please enter valid Title`,
        "string.max": `Please enter {#limit} characters.`
    }),
    firstName: Joi.string().max(100).allow("").required().label("First Name").messages({
        "string.required": `First Name required`,
        "string.pattern.base": `Please enter valid First Name`,
        "string.max": `Please enter {#limit} characters.`
    }),
    secondName: Joi.string().max(100).required().label("Second Name").messages({
        "string.empty": `Second Name required`,
        "string.pattern.base": `Please enter valid Second Name`,
        "string.max": `Please enter {#limit} characters.`,
        "string.required": `Second Name required`,
    }),
    lastName: Joi.string().max(100).allow("").required().label("Last Name").messages({
        "string.empty": `Last Name required`,
        "string.pattern.base": `Please enter valid Last Name`,
        "string.max": `Please enter {#limit} characters.`
    }),
    gender: Joi.string().alphanum().max(50).required().label("Gender").messages({
        "string.empty": `Gender required`,
        "string.pattern.base": `Please enter valid Gender`,
        "string.max": `Please enter {#limit} characters.`
    }),
    nic: Joi.string().alphanum().max(50).required().label("NIC").messages({
        "string.empty": `NIC required`,
        "string.pattern.base": `Please enter valid NIC`,
        "string.max": `Please enter {#limit} characters.`
    }),
    address1:  Joi.string().max(100).allow("", null).label("Address1").messages({
        "string.pattern.base": `Please enter valid Address`,
        "string.max": `Please enter {#limit} characters.`
    }),
    address2:  Joi.string().max(100).allow("", null).label("Address2").messages({
        "string.pattern.base": `Please enter valid Address`,
        "string.max": `Please enter {#limit} characters.`
    }),
    address3:  Joi.string().max(100).allow("", null).label("Address3").messages({
        "string.pattern.base": `Please enter valid Address`,
        "string.max": `Please enter {#limit} characters.`
    }),
    city: Joi.string().alphanum().max(50).allow("", null).label("City").messages({
        "string.pattern.base": `Please enter valid City`,
        "string.max": `Please enter {#limit} characters.`
    }),
    countryCode: Joi.string().alphanum().allow("", null).max(50).label("Country").messages({
        "string.pattern.base": `Please enter valid Country`,
        "string.max": `Please enter {#limit} characters.`
    }),
    homePhoneNo:Joi.number().invalid(0).max(999999999).allow("", null).label("Home Phone Number").messages({
        "number.pattern.base": `Please enter valid Home Phone Number`,
        "number.max": `Invalid Phone Number.`
    }),
    officePhoneNo: Joi.number().invalid(0).allow("", null).max(999999999).label("Office Phone Number").messages({
        "number.pattern.base": `Please enter valid Home Office Number`,
        "number.max": `Invalid Phone Number`
    }),
    mobileNo: Joi.number().invalid(0).allow("", null).max(999999999).label("Mobile Number").messages({
        "number.pattern.base": `Please enter valid Mobile Number`,
        "number.max": `Invalid Phone Number.`
    }),
    email: Joi.string().max(25).allow("", null).label("Email").messages({
        "string.pattern.base": `Please enter valid Email`,
        "string.max": `Please enter {#limit} characters.`
    }),
    question: Joi.string().max(100).allow("", null).label("Question").messages({
        "string.pattern.base": `Please enter valid Question`,
        "string.max": `Please enter {#limit} characters.`
    }),
    answer: Joi.string().max(100).allow("", null).label("Answer").messages({
        "string.pattern.base": `Please enter valid Answer`,
        "string.max": `Please enter {#limit} characters.`
    }),
    registrationNumber:  Joi.string().allow("", null).alphanum().max(10).required().label("Registration Number").messages({
        "string.pattern.base": `Please enter valid Registration Number`,
        "string.max": `Please enter {#limit} characters.`
    }),
    nameToBePrinted:  Joi.string().max(100).allow("", null).label("Name to be printed").messages({
        "string.pattern.base": `Please enter valid Name To Be Printed`,
        "string.max": `Please enter {#limit} characters.`
    }),
    isSupplementary: Joi.boolean().label("Active"),
    dateOfBirth: Joi.string().required().label("Date of birth")
}